import React from "react";
import classNames from "classnames/bind";
import config from "../../../config";
import { TimeInput } from "../TimeInput/TimeInput";
import { DateInput } from "../DateInput/DateInput";
import styles from "./DateTimeInput.module.scss";
import { ControlledDateTimeInputProps, DateTimeInputProps } from "./types";
import FormInputWrapper from "../FormInputWrapper";

const cx = classNames.bind(styles);

/**
 * @deprecated use the new "DateSelectorInput" instead (see Storybook documentation)
 */
export const DateTimeInput = ({
  onChange,
  onBlur,
  value,
  isDisabled,
  showIcon,
  isValidated = false,
  error,
  inputRef,
  id,
  name,
  dateFormat = config.DATE_FORMAT,
  timeFormat = config.TIME_FORMAT,
  datePlaceholder,
  timePlaceholder = "Time",
  use12Hours,
  showSecond,
  disabledDays,
  hiddenDays,
  isClickOutsideEnabled = true,
  isTouched,
  isTouchedRespected = false,
}: DateTimeInputProps) => {
  return (
    <div className={cx("wrapper")}>
      <DateInput
        id={id}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        isDisabled={isDisabled}
        error={error}
        isValidated={isValidated}
        showIcon={showIcon}
        isClickOutsideEnabled={isClickOutsideEnabled}
        inputRef={inputRef}
        format={dateFormat}
        placeholder={datePlaceholder}
        disabled={disabledDays}
        hidden={hiddenDays}
        isTouched={isTouched}
        isTouchedRespected={isTouchedRespected}
      />
      <TimeInput
        id={id}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        isDisabled={isDisabled}
        error={error}
        isValidated={isValidated}
        showIcon={showIcon}
        format={timeFormat}
        use12Hours={use12Hours}
        showSecond={showSecond}
        placeholder={timePlaceholder}
      />
    </div>
  );
};

/**
 * @deprecated use the new "DateSelectorInput" instead (see Storybook documentation)
 */
const ControlledDateTimeInput = (props: ControlledDateTimeInputProps) => {
  return (
    <FormInputWrapper
      {...props}
      as={DateTimeInput}
    />
  );
};

export default ControlledDateTimeInput;
